import cx from "classnames";
import ReactMarkdown from "react-markdown";

type MarkdownProps = {
  content: string;
  isSEOArticle?: boolean;
};

export const Markdown = ({ content, isSEOArticle = false }: MarkdownProps) => {
  return (
    <ReactMarkdown
      components={{
        h1: ({ node, ...props }) => (
          <h2
            className={cx("mt-6 mb-2 text-xl", isSEOArticle && " lg:text-4xl")}
            {...props}
          />
        ),
        h3: ({ node, ...props }) => <h3 className="mt-4 mb-2" {...props} />,
        p: ({ node, ...props }) => (
          <p className={cx(isSEOArticle ? "text-lg" : "text-sm")} {...props} />
        ),
        b: ({ node, ...props }) => <b className="font-semibold" {...props} />,
        ul: ({ node, ...props }) => (
          <ul className="pl-5 text-sm list-disc" {...props} />
        ),
        li: ({ node, ...props }) => <li className="py-1 text-sm" {...props} />,
        a: ({ node, ...props }) => (
          <a
            className={cx(
              "underline break-words",
              isSEOArticle ? "text-lg" : "text-sm",
            )}
            {...props}
          />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
};
